import { useCallback } from "react";

import { type TaskResponse } from "@vega-api/generated/types/taskResponse";

import { useSubmitTask } from "../useSubmitTask";

import { AccreditedInvestorStatusView } from "./AccreditedInvestorStatusView";

type Props = {
  onNextStep: VoidFunction;
  task: TaskResponse;
};

export const AccreditedInvestorStatus = ({ onNextStep, task }: Props) => {
  const { submitTask, isPending } = useSubmitTask();

  const handleSubmit = useCallback(
    (hasAccepted: boolean) => {
      submitTask(
        {
          taskId: task.id!,
          data: { hasAccepted },
        },
        { onSuccess: () => onNextStep() },
      );
    },
    [submitTask, onNextStep, task.id],
  );

  return (
    <AccreditedInvestorStatusView
      isSubmitting={isPending}
      onSubmit={handleSubmit}
    />
  );
};
